import { useState } from 'react';
import { BoutonDocument } from '../../components/BoutonDocument.jsx';
import { tr } from '../../lib/i18n';
import { C } from '../../theme/palette';

/**
 * L'attestation de travail : « X travaille chez nous depuis le … ». Pour un
 * logement, une banque, un permis. Relue en aperçu, puis remise : elle part
 * dans « Mes documents » de l'employé et sa cloche s'allume.
 *
 * @param {{emp: object, voitSalaire?: boolean}} props
 */
export function AttestationTravail({ emp, voitSalaire = false }) {
  const [ouvert, setOuvert] = useState(false);
  const [pour, setPour] = useState('');
  const [avecSalaire, setAvecSalaire] = useState(false);
  if (!emp?.id) return null;
  const corps = () => ({ pour: pour.trim() || null, avecSalaire: voitSalaire && avecSalaire });
  if (!ouvert) {
    return (
      <button
        type="button"
        onClick={() => setOuvert(true)}
        style={{
          width: '100%',
          minHeight: 40,
          borderRadius: 9,
          border: 'none',
          background: C.navy,
          color: C.white,
          fontSize: 11,
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        {tr('🪪 Attestation de travail')}
      </button>
    );
  }
  return (
    <div
      style={{
        border: '1px solid ' + C.border,
        borderRadius: 10,
        padding: 10,
        display: 'grid',
        gap: 8,
      }}
    >
      <div style={{ fontSize: 12, fontWeight: 800 }}>{tr('🪪 Attestation de travail')}</div>
      <div style={{ fontSize: 10.5, color: C.muted }}>
        {tr(
          'Prouve qu’il travaille chez toi aujourd’hui (logement, banque, permis). Sans appréciation.',
        )}
      </div>
      <label style={{ display: 'grid', gap: 3, fontSize: 10.5, fontWeight: 700 }}>
        {tr('Pour quoi ? (facultatif)')}
        <input
          value={pour}
          maxLength={200}
          onChange={(e) => setPour(e.target.value)}
          placeholder={tr('Ex. pour un logement, pour la banque')}
          style={{ border: '1px solid ' + C.border, borderRadius: 8, padding: 8, fontSize: 12 }}
        />
      </label>
      {voitSalaire && (
        <label
          style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 11, cursor: 'pointer' }}
        >
          <input
            type="checkbox"
            checked={avecSalaire}
            onChange={(e) => setAvecSalaire(e.target.checked)}
            style={{ width: 18, height: 18 }}
          />
          {tr('Écrire son salaire mensuel brut')}
        </label>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        <BoutonDocument
          chemin={`/employes/${emp.id}/attestation-de-travail/document/apercu`}
          corps={corps}
          label={tr('📄 Aperçu')}
          color={C.grey}
          full
          sm
        />
        <BoutonDocument
          chemin={`/employes/${emp.id}/attestation-de-travail/document`}
          corps={corps}
          confirmation={() =>
            'Cette attestation est remise à l’employé dans son espace (« Mes documents ») et sa cloche s’allume. La remettre maintenant ?'
          }
          label={tr('Remettre à l’employé')}
          color={C.green}
          full
          sm
        />
      </div>
    </div>
  );
}
